module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jcr8K"))).then(() => parcelRequire('d0iPb'));